import { useState } from "react";
import Modal from "../shared/Modal";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../../redux/features/appData/";
import "./ModalOnlyUserWarning.css";

type ModalOnlyUserWarningProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const ModalOnlyUserWarning = ({
  isOpen = false,
  onClose,
  onContinue,
}: ModalOnlyUserWarningProps) => {
  const storeUser = useSelector(selectUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [confirmText, setConfirmText] = useState<string>("");
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const handleInput = (e: any) => {
    setConfirmText(e.target.value);
    setConfirmed(e.target.value === "CONFIRM");
  };

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal isOpen={isOpen} style={null} onClose={handleClose}>
        <div className="only-user-warning-modal-container">
          <div className="only-user-warning-modal-title">
            <h2>Delete Workspace?</h2>
            <span style={{ color: "var(--text-color-secondary)" }}>
                This workspace will be permanently deleted. All forms, questions and responses will be lost. 
                Confirm you want to delete this workspace by typing CONFIRM below. 
            </span>
          </div>
          
            <div className="only-user-warning-modal-confirm">
                <input
                value={confirmText}
                onChange={handleInput}
                />
            </div>
          
          <div className="only-user-warning-modal-buttons">
            <button
              className="button-cancel"
              onClick={handleClose}>
              Cancel
            </button>
            <button
                onClick={()=>onContinue()}
                className="button-save"
                disabled={!confirmed}
            >
                Yes, Delete
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
